import React from 'react';
import Link from 'next/link';

export default function DealerLocator() {
    return (
        <section className="w-full max-w-[1700px] mx-auto px-0 md:px-12 lg:px-16 py-8 md:py-12" dir="rtl">
            {/* Link with Arrow on Top Right */}
            <div className="flex justify-start mb-3 px-6 md:px-1">
                <Link
                    href="/dealers"
                    className="inline-flex items-center gap-1.5 text-xs sm:text-sm text-gray-500 hover:text-black font-light transition-colors group cursor-pointer"
                >
                    <span>یافتن نزدیک‌ترین مرکز برساوش به شما</span>
                    <span className="text-sm transition-transform group-hover:-translate-x-1 duration-200">‹</span>
                </Link>
            </div>

            {/* Banner Image as button redirecting to /dealers */}
            <Link
                href="/dealers"
                className="block w-full overflow-hidden transition-all duration-300 hover:opacity-90 cursor-pointer"
                title="یافتن نزدیک‌ترین مرکز برساوش به شما"
            >
                <img
                    src="/section7/dealerlocator.svg"
                    alt="یافتن نزدیک‌ترین مرکز برساوش به شما"
                    className="w-full h-[220px] sm:h-[280px] md:h-auto object-cover object-[30%_center] md:object-contain"
                />
            </Link>
        </section>
    );
}